import { createFileRoute } from "@tanstack/react-router";
import { SprzHdParamFormPage } from "@/features/reports/sprz-hd-param-form-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/sprz-wybranych-blozow/parametry/$id")({
	component: SprzHdParamFormPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"page.raporty.sprz-wybranych-blozow.konfiguracja",
			location.pathname,
		);
	},
});
